import { withAsync } from '@helpcenter/with-async';
import { lazy } from 'react-loosely-lazy';
export const ThirdPartyCardConnector = withAsync({
    loader: lazy(() => import(/* webpackChunkName: 'kb-thirdparty-connectors' */ './connectors/index')),
    LoadingSkeleton: () => null,
});
